import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum SuperhumnImporterSecurityFilingLineItemKeys {
  description = 'description',
  country = 'country',
  HtsCode = 'HtsCode',
}

export const superhumnImporterSecurityFilingFileDataSchema = yup.object({
  manufacturer: yup
    .object({
      manufacturerName: yup.string().nullable().optional(),
      manufacturerAddress: yup.string().nullable().optional(),
    })
    .required(),
  importer: yup
    .object({
      importerName: yup.string().nullable().optional(),
      importerAddress: yup.string().nullable().optional(),
    })
    .required(),
  importerReferenceNumber: yup.string().nullable().optional(),
  billOfLadingNumber: yup.string().nullable().optional(),
  seller: yup
    .object({
      sellerName: yup.string().nullable().optional(),
      sellerAddress: yup.string().nullable().optional(),
    })
    .required(),
  buyer: yup
    .object({
      buyerName: yup.string().nullable().optional(),
      buyerAddress: yup.string().nullable().optional(),
    })
    .required(),
  cosignee: yup
    .object({
      cosigneeNumber: yup.string().nullable().optional(),
      cosigneeName: yup.string().nullable().optional(),
      cosigneeAddress: yup.string().nullable().optional(),
    })
    .required(),
  shipTo: yup
    .object({
      shipToName: yup.string().nullable().optional(),
      shipToAddress: yup.string().nullable().optional(),
    })
    .required(),
  AmsMblNumber: yup.string().nullable().optional(),
  AmsHblNumber: yup.string().nullable().optional(),
  containerNumber: yup.string().nullable().optional(),
  vessel: yup.string().nullable().optional(),
  voyageNumber: yup.string().nullable().optional(),
  portOfLoading: yup.string().nullable().optional(),
  dateOfDeparture: yup.string().nullable().optional(),
  countryOfOrigin: yup.string().nullable().optional(),
  portOfFinalDestination: yup.string().nullable().optional(),
  AmsMblScacCode: yup.string().nullable().optional(),
  AmsHblScacCode: yup.string().nullable().optional(),
  containerStuffingLocation: yup.string().nullable().optional(),
  containerStuffer: yup
    .object({
      containerStufferName: yup.string().nullable().optional(),
      containerStufferAddress: yup.string().nullable().optional(),
    })
    .required(),
  grossWeight: yup.string().nullable().optional(),
  numberOfPieces: yup.string().nullable().optional(),
  items: yup
    .array()
    .of(
      yup
        .object({
          [SuperhumnImporterSecurityFilingLineItemKeys.description]: yup
            .string()
            .nullable()
            .optional(),
          [SuperhumnImporterSecurityFilingLineItemKeys.country]: yup.string().nullable().optional(),
          [SuperhumnImporterSecurityFilingLineItemKeys.HtsCode]: yup.string().nullable().optional(),
        })
        .required(),
    )
    .required(),
})

export type SuperhumnImporterSecurityFilingFileData = yup.InferType<
  typeof superhumnImporterSecurityFilingFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<SuperhumnImporterSecurityFilingFileData>

export const superhumnImporterSecurityFilingFileMappings: RequiredFileData = {
  manufacturer: {
    manufacturerName: '0d34f6aa-8c5a-4f3d-b2c4-b93e926a79f5',
    manufacturerAddress: '7e93f418-39d2-44c4-8ae6-d6bce2b9a68a',
  },
  importer: {
    importerName: '4d7b2c19-7a58-4f01-88c6-1c7d6e7c4672',
    importerAddress: 'b8a2c36f-489d-42e9-97f6-91d88e7a9f50',
  },
  importerReferenceNumber: 'b747d60c-e37f-4e4d-b64b-d2b1b2b56268',
  billOfLadingNumber: 'b2fef2f1-0b1f-437b-b51a-1c263b6d4475',
  seller: {
    sellerName: 'a1d7c2f4-b2c7-4319-8f60-94db2e7a8d37',
    sellerAddress: 'e46c9a78-dc3a-46ea-8a76-4f8b9c7a2e91',
  },
  buyer: {
    buyerName: 'f7196a3e-c9b4-4f58-8a63-d4b9c7f25d90',
    buyerAddress: 'c3d8e62f-7e6a-4c2d-96b5-e8a9c7f03d72',
  },
  cosignee: {
    cosigneeNumber: '0417362b-c8f1-4f7a-b48f-a72ecabfca20',
    cosigneeName: 'f08c672d-a6b2-4e79-9a5c-d79c62a4e680',
    cosigneeAddress: 'd93b7e68-4b8f-4c6e-98c4-e7a6c92b4d91',
  },
  shipTo: {
    shipToName: '6c94d83a-b5d9-47f8-9b67-4c92d7b3f680',
    shipToAddress: 'a69b8d74-7e9c-4b5a-93c6-e92a7f3d4619',
  },
  AmsMblNumber: '79a3c6b2-6e4f-4b93-8d7b-2c91a7f06d93',
  AmsHblNumber: 'd2b9f8a7-49c6-47e9-83d7-4b9c76a3f091',
  containerNumber: '4e9f7c63-b5d2-4a6b-8f79-3d7b6e4c92a8',
  vessel: 'b3f74e9a-5c7d-48b9-8d6f-2c9a7b49f07e',
  voyageNumber: 'c2b6a97f-83d4-4f6b-9e79-d3b7a49e6f08',
  portOfLoading: 'f7b4c6e3-9a8d-4c79-83d6-2b91e4a7f09c',
  dateOfDeparture: '8d9b6e47-5c74-4f3a-96b7-d49e6a3c7f09',
  countryOfOrigin: 'a6c93f7d-8b49-4e7a-96f8-b92c7a49e3d7',
  portOfFinalDestination: '4b9f6e8a-3d7c-49b7-96a4-e7c92d49f03a',
  AmsMblScacCode: 'd7b8c94e-63a2-49f7-93a6-b4e97f6c3d72',
  AmsHblScacCode: 'b7f9a6d4-83e9-49c2-97a6-3b92e7c4d8f0',
  containerStuffingLocation: '3f92b6a7-9e4b-47f8-96d3-b7a94c6e29f0',
  containerStuffer: {
    containerStufferName: 'd92b6f47-5a7c-4e9b-83f7-9a6c7d3b48e2',
    containerStufferAddress: 'a74c6d9b-8f2e-49a3-93f6-d79e2b4c7f06',
  },
  grossWeight: '7e94c6b2-a3d8-4f7b-9a6e-d3b49f7c06a8',
  numberOfPieces: '8a6c9b74-f7d3-47e2-93b6-4c7f09a6e2d3',
  items: [
    {
      description: 'd3a6b7f4-83e9-4f7b-93a6-b7c49f2e9d30',
      country: '7b92f64e-5a3d-49e9-96a7-b3f09c2e7a48',
      HtsCode: 'e79b6a47-c2f8-4a9d-93e7-4b9c7a3d6f02',
    },
  ],
}
